import { initPackageColors } from "./modules/package-colors";
/**
 * JS entrypoint (bundled by Rollup/Gulp).
 *
 * Put here:
 * - App boot sequence (what runs on DOMContentLoaded)
 * - Wiring: call each module init via `safeInit()`
 * - High-level event wiring via `initEvents()`
 *
 * Avoid here:
 * - Large feature logic, DOM selectors, or page-specific code (put in `modules/`)
 */


import { safeInit, initEvents } from "./utils";

import { initNav } from "./modules/nav";
import { initUI } from "./modules/ui";
import { handleScroll, initHomeServiceScroll } from "./modules/scroll";
import { initEffects } from "./modules/effect";
import { initMisc } from "./modules/misc";
import { swiperInit } from "./modules/swiper";
import { initGioiThieu } from "./modules/gioithieu";
import { initNiengRang } from "./modules/niengrang";
import { initBangGiaDs } from "./modules/banggia-ds";
import { initAccordionCare } from "./modules/accordion-care";


document.addEventListener("DOMContentLoaded", () => {
	initPackageColors();
	// Start fetching roughly one screen ahead so images are decoded before they scroll in
	const preloadMargin = Math.max(400, Math.round(window.innerHeight * 0.75));
	const observer = lozad(".lozad", {
		rootMargin: `${preloadMargin}px 0px`,
		threshold: 0,
	});

	// First-screen images would otherwise wait for an observer round-trip.
	// A zero-size rect means the element is hidden, so leave it to the observer.
	document.querySelectorAll(".lozad").forEach((el) => {
		const rect = el.getBoundingClientRect();
		const onFirstScreen =
			rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;

		if (onFirstScreen) {
			observer.triggerLoad(el);
		}
	});

	observer.observe();
	window.lozad = lozad;
	window.lozadObserver = observer;
	safeInit(initNav, "nav");
	safeInit(initUI, "ui");
	safeInit(initEffects, "effects");
	safeInit(initMisc, "misc");
	safeInit(swiperInit, "swiper");
	safeInit(initGioiThieu, "gioithieu");
	safeInit(initNiengRang, "niengrang");
	safeInit(initBangGiaDs, "banggia-ds");
	safeInit(initAccordionCare, "accordion-care");
	safeInit(initHomeServiceScroll, "homeServiceScroll");

	initEvents({
		onScroll: handleScroll
	});


	try {
		document.querySelectorAll(".text-fd-up").forEach((el) => {
			const words = el.textContent.trim().split(/\s+/);

			el.innerHTML = words
				.map(
					(word, i) =>
						`<span class="word" style="--i:${i}">${word}&nbsp;</span>`
				)
				.join("");
		});
	} catch (error) {

	}


});

